import React, {ReactElement} from 'react';
import {SHAPE_COLOR_DEFAULT} from '../../../constants';
import {IElementRectangle} from '../../../incase-domain/elements/shapes/rectangle';

interface ElementRectangleComponentProps {
    element: IElementRectangle;
    thickness?: number;
}

ElementRectangleComponent.defaultProps = {
    thickness: 1,
};

function ElementRectangleComponent(props: ElementRectangleComponentProps): ReactElement {
    const {element, thickness} = props;
    const {color, fill} = element;
    const resolvedColor = color || SHAPE_COLOR_DEFAULT;

    return (
        <div className={`c-rectangle${fill ? ' c-rectangle--filled' : ''}`}>
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill={fill ? resolvedColor : 'none'}
                    stroke={resolvedColor}
                    strokeWidth={`${thickness}em`}
                />
            </svg>
        </div>
    );
}

export default ElementRectangleComponent;
